import PropTypes from 'prop-types'
import classNames from 'classnames'
import { ToastContainer } from 'react-toastify'
import { useTranslation } from 'react-i18next'

import { ReactComponent as Op36Logo } from '../../../assets/images/logos/horizontal-logo.svg'
import backgroundVideo from '../../../assets/videos/welcome-page-background-video.mp4'
import backgroundVideoPoster from '../../../assets/images/welcome-page-background-video-poster.webp'

import classes from './AuthLayout.module.scss'

// Branded shell for the unauthenticated pages: logo, tagline and hero video, with the page's own
// content in the action panel. `selectorMode` gives the panel the full screen on narrow viewports,
// which the segment cards need and the two-button welcome screen does not.
const AuthLayout = ({ children, selectorMode = false }) => {
  const { t } = useTranslation()

  return (
    <main className={classNames(classes.authLayout, { [classes.selectorMode]: selectorMode })}>
      <section className={classNames(classes.actionPanel, 'd-flex flex-column align-items-center')}>
        <div className={classNames(classes.formContainer, 'd-flex flex-column align-items-center')}>
          <Op36Logo className={classes.op36Logo} />
          <h2 className={classNames(classes.logoText, 'mt-3')}>{t('auth.welcomePage.tagline')}</h2>

          {children}
        </div>
      </section>

      <ToastContainer theme='colored' />

      <aside className={classes.heroPanel}>
        <div className={classes.heroPanelWrapper}>
          <video autoPlay loop muted poster={backgroundVideoPoster} className={classes.backgroundVideo}>
            <source src={backgroundVideo} type='video/mp4' />
          </video>

          <div className={classes.gradientOverlay} />
        </div>
      </aside>
    </main>
  )
}

AuthLayout.propTypes = {
  children: PropTypes.node,
  selectorMode: PropTypes.bool,
}

export default AuthLayout
